import type { CompetitorSampledReviewDto } from '@up2stay/up2promo-api-client';

import { StarRating } from '@/core/components/reputation/reputation-bits';

const MAX_SAMPLE_REVIEWS = 3;

/**
 * Up to three Google sample reviews of a tracked competitor: stars, a
 * shortened text and the age. Author names stay hidden (DEV-822).
 */
export function CompetitorSampleReviews({
  reviews,
  title,
}: {
  reviews: readonly CompetitorSampledReviewDto[];
  title: string;
}) {
  const shown = reviews
    .filter((review) => review.text.trim())
    .slice(0, MAX_SAMPLE_REVIEWS);
  if (shown.length === 0) return null;
  return (
    <section className="flex flex-col gap-2.5">
      <h4 className="text-muted-foreground text-xs font-medium">{title}</h4>
      <ul className="flex flex-col gap-2">
        {shown.map((review, index) => (
          <li
            key={`${review.publishedAt ?? ''}-${index}`}
            className="bg-muted/40 rounded-[10px] px-3 py-2.5 text-[13px]"
          >
            <div className="mb-1 flex items-center justify-between gap-2">
              <StarRating rating={review.rating} />
              {review.relativeTimeDescription ? (
                <span className="text-muted-foreground text-xs">
                  {review.relativeTimeDescription}
                </span>
              ) : null}
            </div>
            <p className="line-clamp-3 leading-relaxed text-pretty">
              {review.text}
            </p>
          </li>
        ))}
      </ul>
    </section>
  );
}
